import React, { useState } from 'react';
import api from '../../utils/api';
import './AddDepartmentForm.css';

export default function AddDepartmentForm({ branches = [], isLoading: branchesLoading }) {
  const [formData, setFormData] = useState({
    branchId: '',
    name: '',
    description: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      const payload = {
        branchId: formData.branchId,
        name: formData.name.trim(),
        description: formData.description.trim() || undefined,
      };

      const response = await api.post('/api/departments/', payload);

      if (response.data.success) {
        setMessage({
          type: 'success',
          text: response.data.message || 'Departman başarıyla oluşturuldu',
        });
        setFormData({
          branchId: formData.branchId,
          name: '',
          description: '',
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || 'Departman eklenirken bir hata oluştu';
      setMessage({ type: 'error', text: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="department-form-container">
      <h3>Yeni Departman Ekle</h3>
      <p className="department-form-hint">Mevcut bir şubeye departman ekleyebilirsiniz.</p>

      {message.text && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      {branchesLoading ? (
        <p className="department-form-loading">Şubeler yükleniyor...</p>
      ) : branches.length === 0 ? (
        <p className="department-form-empty">
          Önce bir şube tanımlanmalı. Şube sekmesinden şube ekleyebilirsiniz.
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="department-form">
          <div className="form-group">
            <label htmlFor="branchId">Şube</label>
            <select
              id="branchId"
              name="branchId"
              value={formData.branchId}
              onChange={handleChange}
              required
            >
              <option value="">Şube seçin</option>
              {branches.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="name">Departman Adı</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Örn: Kurumsal Müşteri Danışmanı"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Açıklama (isteğe bağlı)</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Örn: Kurumsal bankacılık"
              rows={3}
            />
          </div>

          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'Ekleniyor...' : 'Departman Ekle'}
          </button>
        </form>
      )}
    </div>
  );
}
